export default __webpack_public_path__ + "static/media/mobilecore.64851868.svg";